// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5i-0";
export var eligibilityCardNotEligible = "_5i-1";